import { useNavigate, useRouter } from "@tanstack/react-router";
import { useCallback } from "react";

export function useLeaveMbcFlow(isAlpha = false): () => void {
  const navigate = useNavigate();
  const router = useRouter();

  return useCallback(() => {
    if (router.history.canGoBack()) {
      router.history.back();

      return;
    }

    if (isAlpha) {
      void navigate({ to: "/ai-ad-studio" });

      return;
    }

    void navigate({
      search: { filter: "all", tab: "drafts" },
      to: "/requests",
    });
  }, [isAlpha, navigate, router]);
}
